import apiClient from './client';
import type { FileUploadResponse } from './types';

const API_BASE = (import.meta.env.VITE_API_URL as string) || '';

export async function uploadFile(
  orgSlug: string,
  runId: string,
  file: File,
  onProgress?: (percent: number) => void,
): Promise<FileUploadResponse> {
  const form = new FormData();
  form.append('file', file);
  // Intentionally NOT setting Content-Type: axios detects FormData and emits
  // `multipart/form-data; boundary=...`. Hardcoding the header drops the
  // boundary and breaks the upload.
  const { data } = await apiClient.post<FileUploadResponse>(
    `/api/orgs/${orgSlug}/runs/${runId}/submissions/upload/`,
    form,
    onProgress
      ? {
          onUploadProgress: (e) => {
            if (e.total) onProgress(Math.round((e.loaded / e.total) * 100));
          },
        }
      : undefined,
  );
  return data;
}

export function getFileUrl(key: string): string {
  return `${API_BASE}/api/files/${key}`;
}
